import type { ProgramCenteredListResponse } from "@solomon-apps/shared";

import type { ClientFundingSource } from "@/types/programCenteredYaas";

import { orgApiFetch } from "./orgApiFetch";

/**
 * Client Funding Sources are read-only.
 *
 * A client never supplies a funding address. One reward Funding Account is
 * provisioned per registered Asset, at registration: yaas-api asks Jachin to
 * sync the issuer's Asset, Jachin derives the campaign-0 vault PDA of the
 * merkle-distributor program for that mint and returns it, and yaas-api stores
 * it as a `managedBy: "Jachin"` Funding Source. There is nothing left for an
 * operator to type, so the two POSTs this module used to expose --
 * `/api/org/client/funding-source-inventory` and
 * `/api/org/client/program-funding-sources` -- were removed from yaas-api in
 * 1788c335 and answer 404. Their FE callers went with them; neither was
 * reachable from a page.
 *
 * The read below is left standing but is not whole: 1788c335 removed the GET
 * with the two POSTs, so it 404s against a live yaas-api and only the sim
 * answers it. It survives because deleting it decides what the Program detail
 * shows in place of its Funding Accounts, and there is no replacement to point
 * it at -- yaas-api serves no client funding read at all, `effectiveFundingSources`
 * included. React Query swallows the 404 into an empty list, so the pane renders
 * empty rather than throwing.
 */
export function fetchClientFundingSources(): Promise<ProgramCenteredListResponse<ClientFundingSource>> {
    return orgApiFetch<ProgramCenteredListResponse<ClientFundingSource>>("/api/org/client/funding-source-inventory");
}
